import ConnectPages from '../dashboard/pages/SignupOnboarding/pages/1-ConnectPages/ConnectPages';
import { NewUserInfoFlow } from '../dashboard/pages/SignupOnboarding/pages/NewUserInfoFlow/NewUserInfoFlow';

const ONBOARDING = '/onboarding';

export const OnboardingRoutes = {
  connectPages: {
    path: `${ONBOARDING}/connect-page`,
    component: ConnectPages,
    getLink: () => `${ONBOARDING}/connect-page`,
  },
  userInfo: {
    path: `${ONBOARDING}/user-info`,
    component: NewUserInfoFlow,
    getLink: () => `${ONBOARDING}/user-info`,
  },
};
